<template>
    <div style="  background-color:white;" id="aboutus-mainpage">
        <div class="container-fluid">
            <div class="row main-content">
                <div class="col-md-12 title-container">
                    <div class="small-title">
                        <h4 v-html="state.title"></h4>
                        <hr>
                        <h1 data-aos="fade-right">{{state.subTitle1}}</h1>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6 img-contnt" data-aos="fade-down">
                    <img src="./../../assets/imgs/nosotros_foto1.png" width="100%">
                </div>
                <div class="col-sm-12 col-md-6" data-aos="fade-left">
                    <div class="text-main-container">
                        <div class="medium-title">
                            <h2>{{state.subTitle2}}</h2>
                            <hr>
                        </div>
                        <div class="text-container">
                            <p v-html="state.paragraphText"></p>
                        </div>
                    </div>
                </div>
            </div>
            <mision></mision>
            <valores></valores>
            <organizacion></organizacion>
        </div>
        <div class="col-md-12 footer-container" style="padding:20px;">
            <router-link to="/contacto" tag="a">
                <h3>CONTÁCTANOS</h3>
            </router-link>
            <hr style="border-top:1px solid white;">
            <p>Copy right @2017 - All Rights Reserved</p>
        </div>
    </div>
</template>

<script>
import Mision from './MisionPage'
import Valores from './ValoresPage'
import Organizacion from './OrganizacionPage'



export default {

    methods: {
    },
    components: {
        Mision,
        Valores,
        Organizacion
    },
    computed: {
        state() {
            return this.$store.state.activeList.aboutUsMain
        }
    },
    mounted() {

    }
}
</script>

<style lang="scss" scoped>
@import '~varmix';


.footer-container {
    background-color: $gris;
    color: white;
}

a {
    color: white;
}

h1 {
    font-size: 80pt;
}


#aboutus-mainpage {}

.main-content {
    display: block;
    color: $gris;
    height: 100%;
    background-color: white;
}

.text-main-container {
    padding: 150px;
}

.truck-img-contqainer {
    text-align: left;
}

.img-contnt {
    text-align: left;
}

h4 {
    color: $gris;
    display: inline-block;
}

h2 {
    color: $azul;
    display: inline-block;
    font-size: 30pt;
}

hr {
    display: inline-block;
    vertical-align: middle;
    height: 2px;
    border: 0;
    width: 30%;
    border-top: 2px solid $rojo;
    margin: 1em 1em;
    padding: 0;
}

.floating-text {
    text-align: right;
    margin-top: 30%;
    margin-left: -21%;
    position: absolute;
    width: 250px;
}

.floating-text hr {
    display: inline-block;
    vertical-align: middle;
    height: 2px;
    border: 0;
    width: 30%;
    border-top: 2px solid $azul;
    margin: 1em 1em;
    padding: 0;
}

h1 {
    color: $azul;
    font-size: 40pt;
}

.text-container {
    text-align: left;
    margin-top: 5%;
}

.text-container p {
    width: 400px;
    font-size: 15pt;
}

.small-title {
    padding: 40px 80px;
    text-align: left;
    vertical-align: middle;
}

.medium-title {
    text-align: left;
    vertical-align: middle;
    color: $azul;
}

.title-container {
    margin-top: 100px;
    padding: 50px;
}

.container-fluid,
.col-md-9,
.col-md-6,
.col-md-3,
.col-md-10,
.col-md-12 {
    padding-left: 0px !important;
    padding-right: 0px !important;
}

.row,
.col-md-9,
.col-md-3,
.col-md-10,
.col-md-12 {
    margin-left: 0px!important;
    margin-right: 0px!important;
}

@media screen and (max-width:1000px) {
    .title-container {
        padding: 10px;
    }
    .small-title {
        padding: 40px 30px;
        text-align: left;
        vertical-align: middle;
    }

    .text-main-container {
        width: 100%;
    }

    .text-container p {
        width: 100%;
        font-size: 15pt;
        padding: 30px;
    }

    h2 {
        padding: 20px;
    }

    .img-contnt {
        display: none;
    }
    .title-containe {
        padding: 10px;
    }

    h1 {
        font-size: 30pt;
    }

    .text-main-container {
        padding: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// AboutusPage.vue?51801bc3